import { Component, OnDestroy } from '@angular/core';
import { UIRouter, Transition } from '@uirouter/core';

import { environment, enseigne } from '@environments/environment';
import { Crumb } from '@helpers/crumb';

// // Add `breadcrumb` to typescript definitions for StateObject and StateDeclaration
// declare module "@uirouter/core/lib/state/stateObject" {
// 	interface StateObject {
// 		breadcrumb?: (trans: Transition) => string;
// 	}
// }

// declare module "@uirouter/core/lib/state/interface" {
// 	interface StateDeclaration {
// 		breadcrumb?: (trans: Transition) => string;
// 	}
// }

@Component({
	selector: 'breadcrumbs',
	template: `
		<div class="p-breadcrumb p-component flex justify-content-between">
			<ul class="breadcrumbs">
				<ng-template ngFor let-item let-start="first" let-end="last" [ngForOf]="crumbs">
					<li [ngClass]="{'p-disabled':item.disabled}">
						<span class="p-breadcrumb-chevron pi pi-chevron-right text-primary middle" *ngIf="!start"></span>
						<a
							*ngIf="item.state && !item.state.abstract"
							[uiSref]="item.state"
							class="p-menuitem-link"
							[attr.target]="item.target"
							[attr.title]="item.title"
							[attr.id]="item.id"
							[attr.tabindex]="item.disabled ? null : '0'"
							[uiOptions]="{ reload: '.' }"
						>
							<span *ngIf="start" class="p-menuitem-icon pi pi-home text-primary middle"></span>
							<ng-container *ngIf="item.label && !start">
								<span *ngIf="item.escape !== false; else htmlRouteLabel" class="p-menuitem-text">{{item.label}}</span>
								<ng-template #htmlRouteLabel><span class="p-menuitem-text" [innerHTML]="item.label"></span></ng-template>
							</ng-container>
						</a>
						<span *ngIf="!item.state || item.state.abstract" class="p-menuitem-link">
							<span *ngIf="start" class="p-menuitem-icon pi pi-home text-primary middle"></span>
							<ng-container *ngIf="item.label && !start">
								<span *ngIf="item.escape !== false; else htmlRouteLabel" class="p-menuitem-text">{{item.label}}</span>
								<ng-template #htmlRouteLabel><span class="p-menuitem-text" [innerHTML]="item.label"></span></ng-template>
							</ng-container>
						</span>
					</li>
				</ng-template>
			</ul>
		</div>
	`,
	styles: [`
		.p-breadcrumb ul {
			margin: 0;
			padding: 0;
			list-style-type: none;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}

		.p-breadcrumb .p-menuitem-text {
			line-height: 1;
		}

		.p-breadcrumb .p-menuitem-link {
			text-decoration: none;
		}
	`],
	standalone: false
})
export class BreadcrumbsComponent implements OnDestroy {

	private unsub: any = null;
	public crumbs: Crumb[] = [];

	onDashboard: boolean = false;

	baseTitle: string = '';

	constructor(
		private uiRouter: UIRouter,
	) {
		this.baseTitle = environment[enseigne].title;
		this.updateCrumbs(uiRouter.globals.successfulTransitions.peekTail());
		this.unsub = uiRouter.transitionService.onSuccess({}, trans => this.updateCrumbs(trans));
	}

	ngOnDestroy() {
		this.unsub();
	}

	private updateCrumbs(trans: Transition) {
		let tmp = trans.treeChanges('to');
		this.crumbs = (!tmp)? [] : tmp.filter((node: any) => node.state.breadcrumb)
			.map((node: any) => {
				return {
					state: node.state,
					label: node.state.breadcrumb?.(trans)
				} as Crumb
			});

		this.onDashboard = (this.crumbs.length == 1);
	}
}
